import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
//
// interpolates between a set of colors uzing a bezier spline
//

// @requires utils lab
import Color from '../Color.js';
import '../io/lab/index.js';
import scale from './scale.js';

// nth row of the pascal triangle
var binom_row = function binom_row(n) {
  var row = [1, 1];
  for (var i = 1; i < n; i++) {
    var newrow = [1];
    for (var j = 1; j <= row.length; j++) {
      newrow[j] = (row[j] || 0) + row[j - 1];
    }
    row = newrow;
  }
  return row;
};
var bezier = function bezier(colors) {
  var I, lab0, lab1, lab2;
  colors = colors.map(function (c) {
    return new Color(c);
  });
  if (colors.length === 2) {
    // linear interpolation
    var _colors$map = colors.map(function (c) {
      return c.lab();
    });
    var _colors$map2 = _slicedToArray(_colors$map, 2);
    lab0 = _colors$map2[0];
    lab1 = _colors$map2[1];
    I = function I(t) {
      var lab = [0, 1, 2].map(function (i) {
        return lab0[i] + t * (lab1[i] - lab0[i]);
      });
      return new Color(lab, 'lab');
    };
  } else if (colors.length === 3) {
    // quadratic bezier interpolation
    var _colors$map3 = colors.map(function (c) {
      return c.lab();
    });
    var _colors$map4 = _slicedToArray(_colors$map3, 3);
    lab0 = _colors$map4[0];
    lab1 = _colors$map4[1];
    lab2 = _colors$map4[2];
    I = function I(t) {
      var lab = [0, 1, 2].map(function (i) {
        return (1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i];
      });
      return new Color(lab, 'lab');
    };
  } else if (colors.length === 4) {
    // cubic bezier interpolation
    var lab3;
    var _colors$map5 = colors.map(function (c) {
      return c.lab();
    });
    var _colors$map6 = _slicedToArray(_colors$map5, 4);
    lab0 = _colors$map6[0];
    lab1 = _colors$map6[1];
    lab2 = _colors$map6[2];
    lab3 = _colors$map6[3];
    I = function I(t) {
      var lab = [0, 1, 2].map(function (i) {
        return (1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i];
      });
      return new Color(lab, 'lab');
    };
  } else if (colors.length >= 5) {
    // general case (degree n bezier)
    var labs, row, n;
    labs = colors.map(function (c) {
      return c.lab();
    });
    n = colors.length - 1;
    row = binom_row(n);
    I = function I(t) {
      var u = 1 - t;
      var lab = [0, 1, 2].map(function (i) {
        return labs.reduce(function (sum, el, j) {
          return sum + row[j] * Math.pow(u, n - j) * Math.pow(t, j) * el[i];
        }, 0);
      });
      return new Color(lab, 'lab');
    };
  } else {
    throw new RangeError('No point in running bezier with only one color.');
  }
  return I;
};
export default (function (colors) {
  var f = bezier(colors);
  f.scale = function () {
    return scale(f);
  };
  return f;
});